/**
 * Created by jszh on 2020/6/12.
 */


'use strict';

import SmartAddress from './src/smart';

export default SmartAddress;
